var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.professional !== undefined)?_c('div',{staticClass:"pro-badge flex align-center gap-6"},[(!_vm.noAvatar)?_c('img',{attrs:{"src":_vm.url}}):_vm._e(),_c('div',{staticClass:"name flex align-center wrap"},[[_vm._v(_vm._s(_vm.professional?.family_name || ''))],[_vm._v(_vm._s(_vm.professional?.given_name || ''))]],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }